export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_05.d6f16b2f.jpg";